import AOS from '@netc/aos';
import whenDomReady from 'when-dom-ready';

whenDomReady().then(() => {
  // eslint-disable-next-line no-new
  new AOS();
});
